import { EFormHelper } from './helper';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { EformService } from '../../service/eform.service';
import { FormArray, FormGroup } from '@angular/forms';
import { cloneControl } from './cloneAbstract';
import { UUID } from './uuid';
export class ContextMenuHelper {
   helper = new EFormHelper();
   public contextMenuPosition = { x: '0px', y: '0px' };
   isCopy = false;
   isCut = false;
   dataCopy: FormGroup;
   item: any;
   typeCopy: string;
   uuid = new UUID();
   _onValueChange: FormGroup;
   constructor(public contextMenu: MatMenuTrigger, public service: EformService) {
   }

   onContextMenu($event: MouseEvent, item: any, type: string, sectionIndex?: number, fieldIndex?: number, tableIndex?: number) {
      $event.preventDefault();
      $event.stopPropagation();
      this.contextMenuPosition.x = $event.x - 60 + 'px';
      this.contextMenuPosition.y = $event.y - 45 + 'px';
      if (type === 'new-section' || type === 'new-field') {
         this.contextMenuPosition.x = $event.x + 'px';
         this.contextMenuPosition.y = $event.y + 'px';
      }
      const data = { event: $event, obj: item, type: type, sectionIndex: sectionIndex, fieldIndex: fieldIndex, tableIndex: tableIndex };
      this.contextMenu.menuData = { 'item': data };
      this.contextMenu.closeMenu();
      setTimeout(() => {
         this.contextMenu.menu.focusFirstItem('mouse');
         this.contextMenu.openMenu();
      }, 220);
      this.onHandleEvents();
   }

   onHandleEvents() {
      const _newField = document.getElementsByClassName('new-field');
      const _field = document.getElementsByClassName('field-set');
      for (let i = 0; i < _newField.length; i++) { _newField[i].addEventListener('click', () => this._closeContext()); }
      for (let i = 0; i < _field.length; i++) { _field[i].addEventListener('click', () => this._closeContext()); }
      document.getElementsByClassName('mat-drawer-content')[0].addEventListener('scroll', () => this._closeContext());
      document.addEventListener('click', () => this._closeContext());
   }

   $eventCopy(item: any) {
      const { obj, type, sectionIndex, fieldIndex } = item;
      this.isCopy = true;
      this.isCut = false;
      this.item = item;
      this.typeCopy = type;
      if (type === 'field' || type === 'new-field') {
         const field = this.helper.getFieldAsFormGroupWithIndex(this.service.eForm, sectionIndex, fieldIndex);
         this.dataCopy = cloneControl<FormGroup>(field);
         this._onValueChange = field;
      } else if (type === 'field-table') {
         const field = this.helper.getFieldTableAsFormGroupWithIndex(this.service.eForm, sectionIndex, fieldIndex, item.tableIndex);
         this.dataCopy = cloneControl<FormGroup>(field);
         this._onValueChange = field
      } else {
         this.dataCopy = cloneControl<FormGroup>(obj);
         this._onValueChange = obj;
      }
      this._onValueChange.valueChanges.subscribe(() => setTimeout(() => {
         this.dataCopy = cloneControl<FormGroup>(this._onValueChange);
      }, 1000));
   }

   $eventCut(item: any) {
      this.item = item;
      this.$eventCopy(this.item);
      this.isCut = true;
   }

   $eventPaste(item: any) {
      this._resetKey();
      const _cloneData = cloneControl<FormGroup>(this.dataCopy);
      const { type, sectionIndex, fieldIndex, tableIndex } = item;

      const randomCode = () => {
         const result = Array.from({ length: 4 }, () => {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            return chars[Math.floor(Math.random() * chars.length)];
         }).join('');
         return result;
      };

      const generateFieldName = (name: string) => {
         const sections = this.helper.getSectionAsFormArray(this.service.eForm).value ?? [];
         if (!name) { return ''; }
         let generateName = name + '_' + randomCode();
         while (sections.flatMap((section: any) => section.fields)?.some((field: any) => field?.fieldName === generateName)) {
            generateName = name + '_' + randomCode();
         }
         return generateName;
      }
      if (!this.isCut && this.isCopy) {
         const fieldName = _cloneData.get('fieldName').value;
         _cloneData.get('fieldName').setValue(generateFieldName(fieldName));
         _cloneData.get('fieldName').updateValueAndValidity();
      }
      if (type === 'field' || type === 'new-field') {
         if (this.typeCopy === 'field-table' || item.obj?.type === 'table') {
            if (fieldIndex === undefined) {
               const field = this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex);
               if (item.type === 'new-field') {
                  this.convertToFieldType(_cloneData);
                  field.push(_cloneData);
               }
            } else if (item.obj?.type === 'table') {
               const success = this.tryConvertToTableFieldType(_cloneData);
               if (success) {
                  const field = this.helper.getFieldTableAsFormArray(this.service.eForm, sectionIndex, fieldIndex);
                  if (typeof tableIndex === 'number' && tableIndex >= 0) {
                     field.insert(tableIndex + 1, _cloneData);
                  } else {
                     field.push(_cloneData);
                  }
               } else {
                  return;
               }
            } else {
               this.convertToFieldType(_cloneData);
               const field = this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex);
               field.insert(fieldIndex + 1, _cloneData);
            }
         } else {
            const field = this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex);
            item.type === 'new-field' ? field.push(_cloneData) : field.insert(fieldIndex + 1, _cloneData);
         }
      } else if (type === 'field-table' || type === 'new-table' || type === 'f-control-table') {
         const success = this.tryConvertToTableFieldType(_cloneData);
         if (success) {
            const field = this.helper.getFieldTableAsFormArray(this.service.eForm, sectionIndex, fieldIndex);
            if (type === 'new-table' || type === 'f-control-table') {
               field.push(_cloneData);
            } else {
               const insertIndex = item.tableIndex !== undefined ? item.tableIndex + 1 : field.length;
               field.insert(insertIndex, _cloneData);
            }
         } else {
            return;
         }
      } else {
         if (!this.isCut && this.isCopy) {
            Object.values((_cloneData.controls.fields as FormGroup).controls)?.forEach((field: any) => {
               const fieldName = field.get('fieldName').value;
               field.get('fieldName').setValue(generateFieldName(fieldName));
               field.get('fieldName').updateValueAndValidity();
            });
         }
         const section = this.helper.getSectionAsFormArray(this.service.eForm);
         item.type === 'new-section' ? section.push(_cloneData) : section.insert(sectionIndex + 1, _cloneData);
      }
      this.ifPasteWithCut(item);
      this._onValueChange.valueChanges.subscribe().unsubscribe();
      this.service.eForm.markAsDirty();
   }

   private ifPasteWithCut(item: any) {
      if (!this.isCut) { return; }
      if (this.isCut) {
         if (this.item.type === 'section') {
            const section = this.helper.getSectionAsFormArray(this.service.eForm);
            const _sectionIndex = item.sectionIndex < this.item.sectionIndex ? this.item.sectionIndex + 1 : this.item.sectionIndex;
            section.removeAt(_sectionIndex);
         } else if (this.item.type === 'field-table') {
            const field = this.helper.getFieldTableAsFormArray(this.service.eForm, this.item.sectionIndex, this.item.fieldIndex);
            const _removeIndex = (item.tableIndex < this.item.tableIndex && this._equalFullIndex(this.item.fieldIndex, this.item.sectionIndex, 'field-table')) ? this.item.tableIndex + 1 : this.item.tableIndex;
            field.removeAt(_removeIndex);
         } else {
            const field = this.helper.getFieldAsFormArray(this.service.eForm, this.item.sectionIndex);
            let _removeIndex = (item.fieldIndex < this.item.fieldIndex && this._equalIndex(item.sectionIndex, 'section')) ? this.item.fieldIndex + 1 : this.item.fieldIndex;
            if (_removeIndex < field.length) {
               field.removeAt(_removeIndex - 1);
            } else {
               field.removeAt(field.length - 1);
            }
         }
         this.dataCopy = null;
      }
   }

   private canConvertToTableFieldType(fieldType: string): boolean {
      const convertTypes = [
         'f-textbox',
         'f-radio',
         'f-choice',
         'f-number',
         'f-date',
         'f-email',
         'f-website',
         'f-phone',
         'f-currency'
      ];
      return convertTypes.includes(fieldType);
   }

   private isTableFieldType(fieldType: string): boolean {
      const tableFieldTypes = [
         't-textbox',
         't-radio',
         't-choice',
         't-number',
         't-date',
         't-email',
         't-website',
         't-phone',
         't-currency'
      ];
      return tableFieldTypes.includes(fieldType);
   }

   private convertToTableFieldType(data: any) {
      const item = data.controls['fieldType'];
      switch (item.value) {
         case 'f-textbox': item.setValue('t-textbox'); break;
         case 'f-radio': {
            item.setValue('t-radio');
            const oldType = cloneControl<FormGroup>(data.controls['type']);
            data.controls['type'].setValue('dropdown');
            data.controls['oldType'] = oldType;
            break;
         }
         case 'f-choice': item.setValue('t-choice'); break;
         case 'f-number': item.setValue('t-number'); break;
         case 'f-date': item.setValue('t-date'); break;
         case 'f-email': item.setValue('t-email'); break;
         case 'f-website': item.setValue('t-website'); break;
         case 'f-phone': item.setValue('t-phone'); break;
         case 'f-currency': item.setValue('t-currency'); break;
      }
   }

   private convertToFieldType(data: any) {
      const item = data.controls['fieldType'];
      switch (item.value) {
         case 't-textbox': item.setValue('f-textbox'); break;
         case 't-radio': {
            item.setValue('f-radio');
            if (data.controls['oldType']) {
               data.controls['type'].setValue(data.controls['oldType'].value);
               delete data.controls['oldType'];
            }
            break;
         }
         case 't-choice': item.setValue('f-choice'); break;
         case 't-number': item.setValue('f-number'); break;
         case 't-date': item.setValue('f-date'); break;
         case 't-email': item.setValue('f-email'); break;
         case 't-website': item.setValue('f-website'); break;
         case 't-phone': item.setValue('f-phone'); break;
         case 't-currency': item.setValue('f-currency'); break;
      }
   }

   tryConvertToTableFieldType(data: any): boolean {
      const item = data.controls['fieldType']
      if (!item?.value) {
         return false;
      }
      if (this.isTableFieldType(item.value)) {
         return true;
      }
      if (this.canConvertToTableFieldType(item.value)) {
         this.convertToTableFieldType(data);
         return true;
      }
      return false;
   }

   $eventDelete(item: any) {
      const { type, sectionIndex, fieldIndex, tableIndex } = item;
      if (type === 'section') {
         const section = this.helper.getSectionAsFormArray(this.service.eForm);
         section.removeAt(sectionIndex);
      } else if (type === 'field-table') {
         const section = this.helper.getFieldTableAsFormArray(this.service.eForm, sectionIndex, fieldIndex);
         section.removeAt(tableIndex);
      } else {
         const field = this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex);
         field.removeAt(fieldIndex);
      }

      if (this._isCutOrCopy()) {
         if (this._equalFullIndex(fieldIndex, sectionIndex, type)) {
            this._finishCut(true);
         }
         this.decreaseIndex(item);
      }
   }

   _closeContext() {
      if (this.contextMenu.openMenu) { this.contextMenu.closeMenu(); }
   }

   _resetKey() {
      if (!this.isCut) {
         if (this.typeCopy === 'section') {
            this.dataCopy.controls.key.setValue(this.uuid.getUUIDV4);
            const _tmpArray = this.dataCopy.controls['fields'] as FormArray;
            Object.keys(_tmpArray.controls).forEach(v => {
               const _tmpGroup = _tmpArray.controls[v];
               _tmpGroup.controls.key.setValue(this.uuid.getUUIDV4);
            });
         } else {
            this.dataCopy.controls.key?.setValue(this.uuid.getUUIDV4);
         }
      }
   }

   _isNew(item: any) {
      if (item.type !== 'new-section' && item.type !== 'new-field') {
         return true;
      }
   }

   _isNewSection(item: any) {
      if (item.type === 'new-section' && this.typeCopy === 'section') {
         return true;
      }
   }

   _isNewField(item: any) {
      if (item.type === 'new-field' && this.typeCopy === 'field') {
         return true;
      }
   }

   _isNewFieldTable(item: any) {
   if (
      this.typeCopy === 'field-table' &&
      (
         item.type === 'field' ||
         item.type === 'new-field' ||
         item.type === 'field-table' ||
         item.type === 'new-table' ||
         item.type === 'f-control-table'
      )
   ) {
      return true;
   }
}

   _isNewTableContext(item: any) {
   if (
      this.typeCopy === 'field-table' &&
      (
         item.type === 'new-table' ||
         item.type === 'f-control-table' ||
         item.type === 'field-table'
      )
   ) {
      return true;
   }
}

   decreaseIndex(item: any) {
      if (item.type === 'field' && this.item.fieldIndex > item.fieldIndex) {
         --this.item.fieldIndex;
      } else if (item.type === 'section' && this.item.sectionIndex > item.sectionIndex) {
         --this.item.sectionIndex;
      }
   }

   _isCutOrCopy() {
      return this.isCopy || this.isCut;
   }

   _typeMustMatch(item: any) {
   if (
      item.type === this.typeCopy ||
      this._isNewField(item) ||
      this._isNewSection(item) ||
      this._isNewFieldTable(item) ||
      this._isNewTableContext(item) ||
      this._hasDataCopy()
   ) {
      return true;
   }
   return false;
}

   _equalIndex(index: number, type: string) {
      return type === 'field' ? index === this.item.fieldIndex : index === this.item.sectionIndex;
   }

   _equalFullIndex(fieldIndex: number, sectionIndex: number, type: string) {
      return type === 'field' ? (fieldIndex === this.item.fieldIndex && sectionIndex === this.item.sectionIndex) : sectionIndex === this.item.sectionIndex;
   }

   _finishCut(all?: boolean) {
      if (this.isCut) {
         this.isCopy = false;
         this.isCut = false;
         this.item = '';
         this.dataCopy = null;
      }
      if (all) {
         this.isCopy = false;
         this.isCut = false;
         this.item = '';
         this.dataCopy = null;
      }
   }

   cutUpperIndex(fieldIndex: number, type: string, sectionIndex?: number, tableIndex?: number) {
      if (type === 'section') {
         return this.item.sectionIndex > fieldIndex ? fieldIndex + 1 : fieldIndex;
      } else if (type === 'field-table') {
         // For table columns, check if we're in the same table
         if (this.item.sectionIndex === sectionIndex && this.item.fieldIndex === fieldIndex) {
            return this.item.tableIndex > tableIndex ? tableIndex + 1 : tableIndex;
         } else {
            return tableIndex + 1;
         }
      } else if (this._equalIndex(sectionIndex, 'section')) {
         return this.item.fieldIndex > fieldIndex ? fieldIndex + 1 : fieldIndex;
      } else {
         return fieldIndex + 1;
      }
   }

   _hasDataCopy(): boolean {
      return this.dataCopy !== undefined && this.dataCopy !== null;
   }

}